module.exports = fox._r("images/lines.png", __webpack_public_path__ + "images/lines.png");


//////////////////
// WEBPACK FOOTER
// ./images/lines.png
// module id = 188
// module chunks = 5